export type Fetchmode = 'navigate' | 'same-origin' | 'no-cors' | 'cors' | undefined;

export enum Fetchmodes {
    NAVIGATE = 'navigate',
    SAME_ORIGIN = 'same-origin',
    NO_CORS = 'no-cors',
    CORS = 'cors',
}
